import React from 'react'
import {Button, DotLoading, List, NavBar, SearchBar, Space, Switch, Tabs, Toast} from 'antd-mobile'
import {
  UnorderedListOutline,
  ExclamationOutline,
  MoreOutline,
  SearchOutline,
  UserCircleOutline, ExclamationCircleOutline
} from 'antd-mobile-icons'
import axios from 'axios';
import {useNavigate} from "react-router-dom";
import {LoadingContext, LoadingProvider} from "../../../components/Loading/LoadingContext";
import {paramsToFormData} from "../../../utils/paramsToFormData";
import ApiService from "../../../utils/ApiService";

function WarnList(props:any){
  const navigate = useNavigate()
  const {current:tempObj} = React.useRef<any>({loading:false,first:true,page:1,lastPage:false,total:-1,perList:[]});
  const {current:searchFrom} = React.useRef<any>({type: window.localStorage.getItem("perSeaType")||'all',keyword:window.localStorage.getItem("perSeaWord")||''});
  const [_,upPage]=React.useState(Math.random());
  const { setIsLoading } = React.useContext(LoadingContext);
  const [list,setList]=React.useState([]);
  //触底检测
  const scr = React.useRef<any>()
  const scr2 = React.useRef<any>()//子盒子是否充满

  //在list渲染完成，去检查是否触底
  React.useEffect(()=>{
    //获取加载数据
    if(tempObj.first){
      tempObj.first = false;
      return;
    }
    if(tempObj.lastPage) return;
    const res = scr.current.clientHeight-scr2.current.clientHeight;
    if(res>0){
      console.log('触发了下一页')
      load(true);
    }
  },[list]);

  //在组件渲染完成
  React.useEffect(()=>{
    //获取加载数据
    load();
  },[]);

  //获取设备列表
  const load = async (pageDown=false) =>{
    if(tempObj.loading) return;//防止闪烁
    tempObj.loading = true;
    if(pageDown){
      tempObj.page++;
    }else{
      scr.current.scrollTop = 0;
      tempObj.page = 1;
    }
    searchFrom.page = tempObj.page
    setIsLoading(true);
    const ret = await ApiService.getWarnList(searchFrom);
    setIsLoading(false);
    tempObj.loading = false;

    if(ret && ret.code==1){
      if(pageDown){
        tempObj.perList = [...tempObj.perList,...ret.rows];
      }else{
        scr.current.scrollTop = 0;
        tempObj.perList = ret.rows;
      }
      tempObj.lastPage = ret.lastPage;
      tempObj.total = ret.total;
      setList(tempObj.perList);
    }else if(ret && ret.code == 9){
      upPage(Math.random());
    }else if(ret){
      Toast.show(ret.message)
    }

  }
   const handleClick=(item:any)=>{
    //this.props.history.push('/device/info?id='+item.id+'&nike='+item.nike);
  }

  const handleScroll = () => {
    if(tempObj.lastPage) return;
    console.log('上拉加载好用吗');
    const res = scr.current.scrollHeight - scr.current.scrollTop - scr.current.clientHeight
    //console.log("res",res);
    if (res <= 5) {
      load(true);
      console.log('触底啦');
      //getGoods()
    } else {
      return
    }
  }

  return (
    <>
      <NavBar onBack={()=>navigate('/home')}>预警管理</NavBar>
      <div style={{height:'40px',paddingLeft:5}}>
        <SearchBar placeholder='输入姓名、地址、或电话搜索'style={{display:'inline-block',width:'80%'}} value={searchFrom.keyword}
                   onChange={(value)=> {
                     window.localStorage.setItem("perSeaWord",value);
                     searchFrom.keyword = value;
                     upPage(Math.random());
                   }}
        />
        <Button style={{height:35,marginLeft:5,border:0}} onClick={()=>{load()}}>搜索</Button>
      </div>
      <Tabs activeKey={searchFrom.type}
            onChange={(value)=> {
              window.localStorage.setItem("perSeaType",value);
              searchFrom.type = value;
              upPage(Math.random());
              load();
            }}
      >
        <Tabs.Tab title='全部' key='all'/>
        <Tabs.Tab title='待处置' key='wait'/>
        <Tabs.Tab title='已处置' key='already'/>
      </Tabs>
      <div style={{margin:10}}>共{tempObj.total}条记录, 当前1-{tempObj.perList.length}条记录</div>
      <div style={{position:'absolute',width:'100%',overflowY:'scroll',height:'calc(100% - 164px)'}} ref={scr} onScroll={handleScroll}>
        <div ref={scr2}>
        <List>
          {tempObj.perList.map((item:any)=>{
            return(
              <List.Item key={item.id} prefix={<ExclamationCircleOutline />} description={item.people_address} extra={item.handle_state}
                         onClick={() => {
                           navigate(`/warn/detail?id=${item.id}`);
                         }}>
                {item.people_name} - {item.warn_title}
              </List.Item>)
          })}

          {tempObj.perList.length===0?
            <List.Item key='0' prefix={<ExclamationOutline />} disabled={true} >暂无数据
            </List.Item>:""
          }
        </List>

        {tempObj.lastPage && tempObj.perList.length>0?<div style={{margin:5}}>没有更多了...</div>:null}
        </div>
      </div>
    </>
  )
}
export default WarnList;
